"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperOverlay = exports.Wrapper = exports.OverlayContainer = exports.ImageItem = exports.ImageContainer = exports.Image = exports.ContainerWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setPositionHorizontal = position => {
  switch (position) {
    case 'left':
      return (0, _styledComponents.css)`
      justify-content: flex-start;
      `;
    case 'center':
      return (0, _styledComponents.css)`
      justify-content: center;
      `;
    case 'right':
      return (0, _styledComponents.css)`
      justify-content: flex-end;
      `;
    default:
      return;
  }
};
const setPositionVertical = position => {
  switch (position) {
    case 'top':
      return (0, _styledComponents.css)`
      align-items: flex-start;
      `;
    case 'center':
      return (0, _styledComponents.css)`
     align-items: center;
      `;
    case 'bottom':
      return (0, _styledComponents.css)`
      align-items: flex-end;
      `;
    default:
      return;
  }
};
const Wrapper = _styledComponents.default.div`
  align-items: center;
  justify-content: center;
  display: flex;
  min-height: 100vh;
`;
exports.Wrapper = Wrapper;
const ContainerWrapper = _styledComponents.default.div`
  min-height: 100vh;
  position: relative;
  margin: 0 auto;
  display: flex;
  width: 100%;
  max-width: 80vw;
  @media (max-width: ${_breakpoints.BREAKPOINTS.xs}px) { 
    min-height: ${props => {
  return `calc(${100 / props.aspectRatio}vw - ${40 / props.aspectRatio}px);`;
}};
  }
  ${props => setPositionHorizontal(props.staticPosition)};
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 100%;
    max-width: 100vw;
  }
  @media (max-width: ${_breakpoints.BREAKPOINTS.xs}px) {
    align-items: flex-start;
    min-height: inherit;
    height: fit-content;
  }
`;
exports.ContainerWrapper = ContainerWrapper;
const ImageContainer = _styledComponents.default.div`
  position: absolute;
  @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
    height: -webkit-fill-available;
    max-width: 100vw;
  }
  @media (max-width: ${_breakpoints.BREAKPOINTS.xs}px) {
    width: 100%;
  }
`;
exports.ImageContainer = ImageContainer;
const Image = _styledComponents.default.img`
  max-width: 100%;
  height: 100vh;
  @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
exports.Image = Image;
const ImageItem = _styledComponents.default.img`
width: ${props => `calc(${10 * props.aspectRatio}vh - ${10 * props.aspectRatio}px);`};
`;
exports.ImageItem = ImageItem;
const WrapperOverlay = _styledComponents.default.div`
  width: 100%;
  height: auto;
  display: flex;
  position: relative;
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    height: 100vh;
  }
  ${props => setPositionHorizontal(props.overlayHorizontal)};
  ${props => setPositionVertical(props.overlayVertical)};
`;
exports.WrapperOverlay = WrapperOverlay;
const OverlayContainer = _styledComponents.default.div`
  padding: 80px 0;
  display: flex;
  flex-direction: ${props => props.overlayAlignment === 'inline' ? 'row' : 'column'};
  align-items: center;
`;
exports.OverlayContainer = OverlayContainer;
//# sourceMappingURL=styles.js.map